var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71 9.28995L11.59 13.1699L15.47 9.28995C15.5626 9.19736 15.6725 9.12392 15.7935 9.07382C15.9144 9.02371 16.0441 8.99792 16.175 8.99792C16.3059 8.99792 16.4356 9.02371 16.5565 9.07382C16.6775 9.12392 16.7874 9.19736 16.88 9.28995C16.9726 9.38253 17.046 9.49244 17.0961 9.6134C17.1462 9.73437 17.172 9.86401 17.172 9.99495C17.172 10.1259 17.1462 10.2555 17.0961 10.3765C17.046 10.4975 16.9726 10.6074 16.88 10.6999L12.29 15.2899C12.1975 15.3826 12.0876 15.4562 11.9666 15.5064C11.8457 15.5566 11.716 15.5824 11.585 15.5824C11.454 15.5824 11.3244 15.5566 11.2034 15.5064C11.0824 15.4562 10.9725 15.3826 10.88 15.2899L6.29 10.6999C6.1973 10.6074 6.12375 10.4975 6.07357 10.3766C6.02339 10.2556 5.99756 10.1259 5.99756 9.99495C5.99756 9.86398 6.02339 9.73429 6.07357 9.61332C6.12375 9.49235 6.1973 9.38246 6.29 9.28995C6.68 8.90995 7.32 8.89995 7.71 9.28995Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown2);
export default __webpack_public_path__ + "static/media/arrow_down2.32cb3618.svg";
export { ForwardRef as ReactComponent };